// Vault validation requires that the the addedAt value of each vault entry is
// always larger than the one before. To ensure that this is the case, we need
// a monotonically increasing time source.
//
// There is no guarantee that `new Date()` won't return the same time twice.
// Firefox limits the clock resolution to 2ms by default to prevent fingerprinting.
//
// As a result, we cannot rely on `new Date()` to provide monotonically increasing time.
//
// This service provides a monotonically increasing time source.
export class MonotonicTimeSource {
    now() {
        var _a;
        // eslint-disable-next-line no-restricted-syntax
        const current = new Date();
        if (this.lastReturnedDate && current <= this.lastReturnedDate) {
            current.setMilliseconds(this.lastReturnedDate.getMilliseconds() + 1);
        }
        // Jest gets hang up on uncleared timeouts
        if (typeof process === 'undefined' || ((_a = process === null || process === void 0 ? void 0 : process.env) === null || _a === void 0 ? void 0 : _a.NODE_ENV) !== 'test') { // Vite build leaves `process` undefined
            clearTimeout(this.setTimeoutId);
            this.setTimeoutId = setTimeout(() => {
                // Clear stored time after a while, so that we don't get stuck in the future,
                // if the system clock was set to a future date at some point in time.
                this.setTimeoutId = undefined;
                this.lastReturnedDate = undefined;
            }, 1000);
        }
        this.lastReturnedDate = current;
        return new Date(current); // copy it as it may get mutated by the consumer
    }
}
